import {FEE_BETA_KEY, isFeeBetaToggleVisible} from 'common/helpers/fee'
import {useLocation} from 'react-router'

import BetaToggle from './Toggle'

type Props = {
  /** Wrapper class; only rendered when the toggle is visible on this route. */
  className?: string
}

/** Header toggle between the legacy fee iframe and the native fee page. */
const FeeBetaToggle = ({className}: Props) => {
  const {pathname} = useLocation()

  if (!isFeeBetaToggleVisible(pathname)) {
    return null
  }

  const toggle = (
    <BetaToggle moduleKey={FEE_BETA_KEY} color='primary' size='sm' title='FEE.BETA_TOGGLE_TITLE' />
  )

  return className ? <div className={className}>{toggle}</div> : toggle
}

export default FeeBetaToggle
